<template>
  <div class="collection-settings">
    <p>Adjust overdue payment duration and status update.</p>

    <b-row class="my-4">
      <b-col lg="5" v-for="(setting, index) in statusList" :key="index">
        <b-card no-body>
          <b-card-header class="d-flex align-items-center justify-content-between">
            <h3 class="mb-0" :class="setting.color_class">{{ setting.name }}</h3>
            <div class="d-flex">
              <span class="mr-2">Enable</span>
              <el-switch v-model="setting.is_enabled" :active-value="1" :inactive-value="0" active-color="#0BC196"></el-switch>
            </div>
          </b-card-header>
          <div class="p-3">
            <div class="d-flex align-items-center mb-3">
              <p>If a customer hasn't made a payment within</p>
              <b-form-input class="w-25 mx-2" v-model="setting.tat_day" style="max-width: 60px;"></b-form-input>
              <p>days,</p>
            </div>
            <div class="d-flex align-items-center mb-3">
              <p>the status will be automatically updated to </p>
              <el-select v-model="setting.next_id" placeholder="Select" size="mini" class=" mx-2">
                <el-option v-for="item in setStatusOpt(setting)" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="my-5">
      <b-col cols="8" md="6" lg="4">
        <el-button type="primary" @click.prevent="updateAll()" :loading="is_loading_btn">Save</el-button>
        <!-- <el-button type="primary" plain>Reset to default</el-button> -->
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Select, Option, Switch, Button } from 'element-ui'
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore'

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
    [Button.name]: Button,
  },
  data() {
    return {
			is_loading_btn:false,
			statusList:[]
    }
  },
	created() {
		this.setStatusList();
	},
	computed: {
		...mapState(useCommonStore, ['allStatus'])
	},
	watch: {
		'allStatus': {
			handler(newValue, oldValue) {
				this.setStatusList()
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useCommonStore, ['getAllStatus','updateStatus']),
		setStatusList() {
			if (!_gHlp.isEmpty(this.allStatus)) {
				this.statusList = this.allStatus.filter(itm => itm.module == 'collection');
			}
		},
		setStatusOpt(cur) {
			if (!_gHlp.isEmpty(this.statusList)) {
				return this.statusList.filter(itm => itm.id != cur.id);
			}
		},
		updateAll(){
			this.is_loading_btn = true;
			let calls = [];
			for (let i = 0; i < this.statusList.length; i++) {
				const sts = this.statusList[i];
				
				calls.push(this.updateStatus(sts.id,sts))
			}

			Promise.all(calls)
				.then(resp => {
					this.getAllStatus(true).then(resp => {
						this.setStatusList();
					});
					_gNotif.notifySuccess('<b>Collection Status:</b> - Successfully Updated.')
					this.is_loading_btn = false;
			})
				
		}
  }
}
</script>